import { ResultPropsGenericWithOriginal } from '../../../../../types/Survey/Analysis/FactorValues'
import { genericFactorValues } from '../../getFactorValues'
import { Values } from '../../../../../types/Survey/Analysis/Calculation'

const getWorkcafe = (values: Values): ResultPropsGenericWithOriginal => {
  if (!!values.workcafe) {
    return values.workcafe
  }
  let value = values.mitarbeiter * (!isNaN(genericFactorValues.workcafe.value) ? genericFactorValues.workcafe.value : 0)
  return {
    practicalQM: value,
    originalPracticalQM: value,
  }
}

export default getWorkcafe
